var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1403_2325)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1403_2325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 6C16 2.68629 18.6863 0 22 0H106C109.314 0 112 2.68629 112 6V122C112 125.314 109.314 128 106 128H22C18.6863 128 16 125.314 16 122V6Z",
    fill: "#FCFCFD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 6C16 2.68629 18.6863 0 22 0H106C109.314 0 112 2.68629 112 6V122C112 125.314 109.314 128 106 128H22C18.6863 128 16 125.314 16 122V6Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 0.8H106C108.872 0.8 111.2 3.12812 111.2 6V122C111.2 124.872 108.872 127.2 106 127.2H22C19.1281 127.2 16.8 124.872 16.8 122V6C16.8 3.12812 19.1281 0.8 22 0.8Z",
    stroke: "#DDE1E6",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 128H106C109.314 128 112 125.314 112 122V118C112 121.314 109.314 124 106 124H22C18.6863 124 16 121.314 16 118V122C16 125.314 18.6863 128 22 128Z",
    fill: "#DDE1E6"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1403_2325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1832 62.2783L44.8809 57.8132V90.806C44.8809 92.3127 46.1023 93.5342 47.609 93.5342H91.269C92.7757 93.5342 93.9971 92.3127 93.9971 90.806V78.6504L70.1832 62.2783Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1832 34H47.609C46.1023 34 44.8809 35.2214 44.8809 36.7282V48.8837L70.1832 63.7674L83.5785 68.2326L93.9971 63.7674V48.8837L70.1832 34Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8809 48.8835H70.1832V63.7673H44.8809V48.8835Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M62.9899 45.907H44.8809V83.1163H62.9899C64.4946 83.1114 65.7132 81.8928 65.7181 80.3881V48.6352C65.7132 47.1305 64.4946 45.9119 62.9899 45.907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M61.5015 47.3953H44.8809V84.6046H61.5015C63.0062 84.5997 64.2248 83.3811 64.2297 81.8764V50.1234C64.2248 48.6187 63.0062 47.4002 61.5015 47.3953Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M61.5015 47.3953H44.8809V81.6278H61.5015C63.0062 81.6229 64.2248 80.4043 64.2297 78.8996V50.1234C64.2248 48.6187 63.0062 47.4002 61.5015 47.3953Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.0131 47.3953H44.8809V81.6278H60.0131C61.5178 81.6229 62.7364 80.4043 62.7413 78.8996V50.1234C62.7364 48.6187 61.5178 47.4002 60.0131 47.3953Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7282 47.3953H60.016C61.5227 47.3953 62.7442 48.6167 62.7442 50.1234V77.4112C62.7442 78.918 61.5227 80.1394 60.016 80.1394H32.7282C31.2214 80.1395 30 78.918 30 77.4113V50.1234C30 48.6167 31.2214 47.3953 32.7282 47.3953Z",
    fill: "url(#paint0_linear_1403_2325)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4502 72.6354L44.1894 63.7424L38.9309 54.8984H43.1609L46.0305 60.5543C46.2954 61.0915 46.477 61.4904 46.5752 61.7539H46.6124C46.801 61.3252 46.9994 60.909 47.2078 60.5051L50.2753 54.9014H54.1585L48.7661 63.6932L54.2954 72.6354H50.1637L46.8491 66.4274C46.693 66.1632 46.5605 65.8858 46.4532 65.5984H46.4041C46.307 65.88 46.1782 66.1496 46.0201 66.4021L42.6072 72.6354H38.4502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2733 34H70.1875V48.8837H94.0015V36.7282C94.0015 35.2214 92.78 34 91.2733 34Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1875 63.7676H94.0015V78.6513H70.1875V63.7676Z",
    fill: "#107C41"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1403_2325",
    x: 16,
    y: 0,
    width: 96,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1403_2325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1403_2325",
    x1: 35.6883,
    y1: 45.2635,
    x2: 57.0559,
    y2: 82.2712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1403_2325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1403_2325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 59.5349,
    fill: "white",
    transform: "translate(30 34)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.dac5e77530f657e67db6c12a6ab978ed.svg";
export { ForwardRef as ReactComponent };